import Vue from 'vue'
// console.log('start login http module')
const requireHttpModule = require.context('./modules', false, /\.js/)

const modules = requireHttpModule.keys().reduce((p, n) => {
  const name = n.replace(/\.\//, '').replace(/\.js/, '')
  const store = {}
  // console.log(requireHttpModule(n))
  store[name] = requireHttpModule(n)
  return { ...p, ...store }
}, {})
// console.log('http module ==> ', modules)

Plugin.install = function (Vue, options) {
  Vue.$http = modules
  window.$http = modules
  Object.defineProperties(Vue.prototype, {
    http: {
      get () {
        return modules
      }
    },
    $http: {
      get () {
        return modules
      }
    }
  })
}

Vue.use(Plugin)

export default modules
